export const types = {
  SET_WEBSERVICE_ERROR_HANDLER: 'ERRORMANAGEMENT/SET_WEBSERVICE_ERROR_HANDLER',
  SET_HANDLED_ERRORS: 'ERRORMANAGEMENT/SET_HANDLED_ERRORS',
};

export const initialState = {
  handledErrors: null,
  webServiceErrorHandler: null,
};

// eslint-disable-next-line @typescript-eslint/default-param-last
const ErrorManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_WEBSERVICE_ERROR_HANDLER: {
      const { webServiceErrorHandler } = action.payload;

      return {
        ...state,
        webServiceErrorHandler,
      };
    }
    case types.SET_HANDLED_ERRORS: {
      const { handledErrors } = action.payload;

      return {
        ...state,
        handledErrors,
      };
    }
    default: return { ...state };
  }
};

export const actions = {
  setWebServiceErrorHandler: webServiceErrorHandler => ({
    type: types.SET_WEBSERVICE_ERROR_HANDLER,
    payload: {
      webServiceErrorHandler,
    },
  }),
  setHandledErrors: handledErrors => ({
    type: types.SET_HANDLED_ERRORS,
    payload: {
      handledErrors,
    },
  }),
};

export default ErrorManagementReducer;
